import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { WarningComponentComponent } from './warning-component/warning-component.component';
import { ColorPickerComponent } from './color-picker/color-picker.component';
import { AuthInputComponent } from './auth-input/auth-input.component';
import { DashboardHeaderComponent } from './dashboard-header/dashboard-header.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddChoosePhotoComponent } from './add-choose-photo/add-choose-photo.component';
import { EmptyMessageComponent } from './empty-message/empty-message.component';
import { NextPrevToolbarComponent } from './next-prev-toolbar/next-prev-toolbar.component';
import { DashboardHeaderDmComponent } from './dashboard-header-dm/dashboard-header-dm.component';
import { DashboardButtonComponent } from './dashboard-button/dashboard-button.component';
import { DeviceInfoComponent } from './device-info/device-info.component';
import { ModalHeaderDmComponent } from './modal-header-dm/modal-header-dm.component';
import { BackContinueToolbarComponent } from './back-continue-toolbar/back-continue-toolbar.component';
import { TopnavigationsBtnsDmComponent } from './topnavigations-btns-dm/topnavigations-btns-dm.component';
import { TopnavigationsSegmentsDmComponent } from './topnavigations-segments-dm/topnavigations-segments-dm.component';
import { SyncWarningMsgComponent } from './sync-warning-msg/sync-warning-msg.component';
import { PortraitOrientationComponent } from './portrait-orientation/portrait-orientation.component';
import { ScreenInnerLoadingComponent } from './screen-inner-loading/screen-inner-loading.component';
import { SingleChoiceFieldComponent } from './single-choice-field/single-choice-field.component';
import { MultipleChoiceFieldComponent } from './multiple-choice-field/multiple-choice-field.component';
import { SinglelineTextFieldComponent } from './singleline-text-field/singleline-text-field.component';
import { MultilineTextFieldComponent } from './multiline-text-field/multiline-text-field.component';
import { DateFieldComponent } from './date-field/date-field.component';
import { DateTimeFieldComponent } from './date-time-field/date-time-field.component';
import { TimeFieldComponent } from './time-field/time-field.component';
import { NumberIntegerFieldComponent } from './number-integer-field/number-integer-field.component';
import { NumberDecimalFieldComponent } from './number-decimal-field/number-decimal-field.component';
import { DropdownFieldComponent } from './dropdown-field/dropdown-field.component';
import { ExposureComponent } from './exposure/exposure.component';
import { QuestionListHeaderComponent } from './question-list-header/question-list-header.component';
import { CustomQuestionsContainerComponent } from './custom-questions-container/custom-questions-container.component';
import { PhotoFieldComponent } from './photo-field/photo-field.component';
import { SectionTitleComponent } from './section-title/section-title.component';
import { ArchivedItemComponent } from './archived-item/archived-item.component';
import { CustomIonRefreshLoaderComponent } from './custom-ion-refresh-loader/custom-ion-refresh-loader.component';
import { ModalHeaderComponent } from './modal-header/modal-header.component';
import { ConfirmBoxFieldComponent } from './confirm-box-field/confirm-box-field.component';
import { RaTemplateInputComponent } from './ra-template-input/ra-template-input.component';
import { TranslateModule } from '@ngx-translate/core';
import { QrCodeScanFieldComponent } from './qr-code-scan-field/qr-code-scan-field.component';
import { MatrixThreeDFieldComponent } from './matrix-three-d-field/matrix-three-d-field.component';
import { SignatureAreaComponent } from './signature-area/signature-area.component';
import { InformSignatureContainerComponent } from './inform-signature-container/inform-signature-container.component';
import { SearchResultsPopoverComponent } from './search-results-popover/search-results-popover.component';
import { TreeListComponent } from './tree-list/tree-list.component';
import { AttachementExtensionComponent } from './attachemetExtension/attachement-extension.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { JsPdfViewerComponent } from "./js-pdf/js-pdf.component";
import { SearchPersonalMode } from "./search-personal-mode/search-personal-mode.component";
import { HeaderScoreDisplayComponent } from './header-score-display/header-score-display.component';
import { ActivityPopupComponent } from './activity-popup/activity-popup.component';
import { UserSelectorComponent } from './user-selector/user-selector.component';
import { RequiredAsteriskComponent } from './required-asterix/required-asterix.component';
import { BodyMapCustomQuestionComponent } from './body-map-custom-question/body-map-custom-question.component';
@NgModule({
	declarations: [
		SearchPersonalMode,
		AttachementExtensionComponent,
		TreeListComponent,
		WarningComponentComponent,
		ColorPickerComponent,
		AuthInputComponent,
		DashboardHeaderComponent,
		AddChoosePhotoComponent,
		EmptyMessageComponent,
		NextPrevToolbarComponent,
		DashboardHeaderDmComponent,
		DashboardButtonComponent,
		DeviceInfoComponent,
		ModalHeaderDmComponent,
		ModalHeaderComponent,
		BackContinueToolbarComponent,
		TopnavigationsBtnsDmComponent,
		TopnavigationsSegmentsDmComponent,
		SyncWarningMsgComponent,
		PortraitOrientationComponent,
		ScreenInnerLoadingComponent,
		SingleChoiceFieldComponent,
		MultipleChoiceFieldComponent,
		ConfirmBoxFieldComponent,
		SinglelineTextFieldComponent,
		MultilineTextFieldComponent,
		DateFieldComponent,
		DateTimeFieldComponent,
		TimeFieldComponent,
		NumberIntegerFieldComponent,
		NumberDecimalFieldComponent,
		DropdownFieldComponent,
		ExposureComponent,
		QuestionListHeaderComponent,
		CustomQuestionsContainerComponent,
		PhotoFieldComponent,
		SectionTitleComponent,
		ArchivedItemComponent,
		CustomIonRefreshLoaderComponent,
		RaTemplateInputComponent,
		QrCodeScanFieldComponent,
		MatrixThreeDFieldComponent,
		SignatureAreaComponent,
		InformSignatureContainerComponent,
		SearchResultsPopoverComponent,
		JsPdfViewerComponent,
		HeaderScoreDisplayComponent,
		ActivityPopupComponent,
		UserSelectorComponent,
		RequiredAsteriskComponent,
		BodyMapCustomQuestionComponent
	],
	imports: [IonicModule, CommonModule, FormsModule, ReactiveFormsModule, TranslateModule,PdfViewerModule],
	exports: [
		AttachementExtensionComponent,
		SearchPersonalMode,
		TreeListComponent,
		WarningComponentComponent,
		ColorPickerComponent,
		AuthInputComponent,
		DashboardHeaderComponent,
		AddChoosePhotoComponent,
		EmptyMessageComponent,
		NextPrevToolbarComponent,
		DashboardHeaderDmComponent,
		DashboardButtonComponent,
		DeviceInfoComponent,
		ModalHeaderDmComponent,
		ModalHeaderComponent,
		BackContinueToolbarComponent,
		TopnavigationsBtnsDmComponent,
		TopnavigationsSegmentsDmComponent,
		SyncWarningMsgComponent,
		PortraitOrientationComponent,
		ScreenInnerLoadingComponent,
		SingleChoiceFieldComponent,
		MultipleChoiceFieldComponent,
		ConfirmBoxFieldComponent,
		SinglelineTextFieldComponent,
		MultilineTextFieldComponent,
		DateFieldComponent,
		DateTimeFieldComponent,
		TimeFieldComponent,
		NumberIntegerFieldComponent,
		NumberDecimalFieldComponent,
		DropdownFieldComponent,
		ExposureComponent,
		QuestionListHeaderComponent,
		CustomQuestionsContainerComponent,
		PhotoFieldComponent,
		SectionTitleComponent,
		ArchivedItemComponent,
		CustomIonRefreshLoaderComponent,
		RaTemplateInputComponent,
		QrCodeScanFieldComponent,
		MatrixThreeDFieldComponent,
		SignatureAreaComponent,
		InformSignatureContainerComponent,
		SearchResultsPopoverComponent,
		HeaderScoreDisplayComponent,
		ActivityPopupComponent,
		UserSelectorComponent,
		RequiredAsteriskComponent,
		BodyMapCustomQuestionComponent
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComponentsModule { }
